export const API_AGENCIES = 'core/agencies';
export const API_ADMIN_PANEL_AGENCIES = 'admins/admin-panel/agencies';
